import './App.css';
import Converter from './Converter';
// import { Button } from "antd";

function App() {
  return (
    <>
    <Converter />
    </>
  );
}

export default App; 